import { ClientRequestForm } from '@/components/ClientRequestForm';
import { useSubmitTermination } from '@/api/hooks';

export function TerminationRequest() {
  const submit = useSubmitTermination();
  return (
    <ClientRequestForm
      title="Client Termination Request"
      description="Select one or more clients to terminate. The termination date is the date you submit. Selecting a master client lists its sub-clients. On submit, you receive a receipt and the admin team is notified. The client record is updated in Maconomy separately."
      scope="active"
      dateLabel="Effective Termination Date"
      submit={submit}
      termination
    />
  );
}
